// extracted by mini-css-extract-plugin
export default {"goBackButton":"GoBackButton_goBackButton__iF1IJ"};